import React from "react";
import Slider from "react-slick";
import { Container, Box } from '@mui/material';
import "../style/NewsEvents.css";
import newsImage1 from '../images/News-event-01.jpeg';
import newsImage2 from '../images/News-event-02.jpeg';
import newsImage3 from '../images/NewsImage1.jpeg';
import newsImage4 from '../images/NewsImage2.jpeg';
import newsImage5 from '../images/NewsImage3.jpeg';
import newsImage6 from '../images/NewsImage4.jpeg';
import newsImage7 from '../images/NewsImage5.jpeg';

const NewsEventsComponent = () => {
  // Array of news/event images
  const newsEvents = [
    { id: 1, image: newsImage1, alt: 'News Event 1' },
    { id: 2, image: newsImage2, alt: 'News Event 2' },
    { id: 3, image: newsImage3, alt: 'News Event 3' },
    { id: 4, image: newsImage4, alt: 'News Event 4' },
    { id: 5, image: newsImage5, alt: 'News Event 5' },
    { id: 6, image: newsImage6, alt: 'News Event 6' },
    { id: 7, image: newsImage7, alt: 'News Event 7' },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
    fade: true,
    customPaging: (i) => (
      <div className="news-custom-dot">
        <span>♦</span>
      </div>
    ),
    dotsClass: "slick-dots news-custom-dots",
  };

  return (
    <Container className="news-events-container" id="news-events">
      <Box className="news-events-title">
        NEWS / EVENTS
      </Box>
      <Box className="news-events-subtitle">
        VISION MAKES US WHO WE ARE
      </Box>

      <div className="news-events-carousel-wrapper">
        <Slider {...settings} className="news-events-slider">
          {newsEvents.map((event) => (
            <div key={event.id} className="news-slide">
              <img src={event.image} alt={event.alt} className="news-image" />
            </div>
          ))}
        </Slider>
      </div>
    </Container>
  );
};

export default NewsEventsComponent;
